import classnames from 'classnames/bind';
import { safeSqlFormatter } from 'app/lib/utils';
import { SqlCodeViewer } from 'app/components/core/CodeEditor';
import { Dialog, ModalBody, ModalHeader, ModalTitle } from 'app/components/core/Modal';
import * as styles from './WarehouseLoadDialog.css';

const cx = classnames.bind(styles);

export function SqlQueryDialog({ queryId, sql = '', ...props }) {
    return (
        <Dialog id="sql-query-dialog" width={800} height={600} isResizable {...props}>
            <ModalHeader icon="op-sql">
                <ModalTitle>{queryId}</ModalTitle>
            </ModalHeader>
            <ModalBody className={cx('query-preview')}>
                <SqlCodeViewer sql={safeSqlFormatter(sql) ?? sql} allowCopyToClipboard fullHeight />
            </ModalBody>
        </Dialog>
    );
}
